module.exports = {
    "id": "muff-cave",
    "title": "Muff's Cave",
    "character-image": "/provision/projects/muff-cave/muff.png",
    "project_file": "muff-cave.gbp",
    "thumbnail": "/provision/projects/muff-cave/muff-cave.png",
    "category": "games",
    "toolbar":{
      "glitches":[],
      "parts":[]
    }
  }
  ;